export default {
  CREATE: 'FINANCIAL/CREATE',
  UPDATE: 'FINANCIAL/UPDATE',
  DELETE: 'FINANCIAL/DELETE'
};
